import { Injectable } from '@angular/core';

import { TranscriptImportHook } from './hook';
import { WillImportContext } from './model/will-import-context.model';

@Injectable({ providedIn: 'root' })
export class TranscriptImportHookService {
    private readonly _hooks: TranscriptImportHook[];

    constructor() {
        this._hooks = [];
    }

    register(hook: TranscriptImportHook): void {
        if (!this._hooks.includes(hook)) {
            this._hooks.push(hook);
        }
    }

    unregister(hook: TranscriptImportHook): void {
        const index = this._hooks.indexOf(hook);
        if (index !== -1) {
            this._hooks.splice(index, 1);
        }
    }

    willImport(context: WillImportContext): Array<Promise<boolean>> {
        const proms: Array<Promise<any>> = [];
        this._hooks.forEach((e) => {
            if (e.tiWillImport != null) {
                proms.push(e.tiWillImport(context));
            }
        });
        return proms;
    }
}
